import { render } from "./CommentItemPreview.vue?vue&type=template&id=67f0b932"
import script from "./CommentItemPreview.vue?vue&type=script&lang=js"
export * from "./CommentItemPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__